import { KeyboardBackspaceOutlined } from '@mui/icons-material';
import { Box, IconButton, Typography, useTheme } from '@mui/material';
import React from 'react';

/**
 * DrawerHeaderBox
 *
 * A header component for a drawer with a back button, title, and optional subtitle.
 *
 * @param {function} handleBack - Callback function triggered when the back button is clicked.
 * @param {string} heading - The main heading text displayed in the drawer header.
 * @param {string} para - Optional subtitle text displayed below the heading.
 * @param {object} textBoxSx - Custom styles for the text box area containing the heading and subtitle.
 *
 * @returns {JSX.Element} - A header component with back navigation and customizable text.
 */
function DrawerHeaderBox({ handleBack = () => {}, heading = '', para = '', textBoxSx = {}, hideBackBtn = false }) {
    const theme = useTheme();
    return (
        <Box padding={`${theme.typography.generic.large} ${theme.typography.generic.xLarge}`} bgcolor={theme.palette.background.neutralPrimary} color={'text.inverse'} display={'flex'} minHeight={'4.6rem'}>
            {!hideBackBtn && (
                <IconButton onClick={handleBack} color="inherit">
                    <KeyboardBackspaceOutlined fontSize="medium" />
                </IconButton>
            )}
            <Box sx={{ paddingRight: '30px', width: '100%', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', ...textBoxSx }}>
                <Typography component={'h2'} variant="subtitle2" color={'text.inverse'} fontSize={'customFontSize.medium'} fontWeight={'fontWeightMedium'} sx={{ lineHeight: 1.7 }}>
                    {heading}
                </Typography>
                {para && (
                    <Typography variant="body2" color={'text.inverse'} fontSize={'customFontSize.small'} fontWeight={'fontWeightRegular'}>
                        {para}
                    </Typography>
                )}
            </Box>
        </Box>
    );
}

export default DrawerHeaderBox;
